import { ArrowDownIcon, ArrowForwardIcon } from "@chakra-ui/icons";
import { GridItem, GridItemProps, Icon } from "@chakra-ui/react";
import React from "react";

export function ArrowGridItem(props: GridItemProps): React.ReactElement {
  return (
    <GridItem
      justifySelf="center"
      alignSelf="center"
      w="fit-content"
      {...props}
    >
      <Icon as={ArrowDownIcon} display={{ base: "block", sm: "none" }} />
      <Icon as={ArrowForwardIcon} display={{ base: "none", sm: "block" }} />
    </GridItem>
  );
}
